/* kēburu theme script: product page (options, gallery, add to bag) and the bag drawer. */
(function () {
  'use strict';

  var R = (window.keburu && window.keburu.routes) || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js', checkout: '/checkout' };
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';

  function money(cents) {
    var n = cents / 100;
    var whole = Math.round(n * 100) % 100 === 0;
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return '£' + (whole ? n.toFixed(0) : n.toFixed(2)); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sizeImg(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    try { var u = new URL(src, location.href); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  }

  // pastel version of each cable colour, as light as the neutral grey tile
  var TINTS = {
    pink: ['#fce8ee', '#f8d6e1'], blue: ['#e4f6f5', '#cfeeec'], mint: ['#e4f6f5', '#cfeeec'],
    green: ['#e5f7e7', '#d0f0d4'], purple: ['#eee9f9', '#e0d7f5'], lilac: ['#eee9f9', '#e0d7f5'],
    black: ['#ebeaee', '#dddce2']
  };

  /* ---------------- bag drawer ---------------- */
  var drawer = document.querySelector('[data-drawer]');
  var scrim = document.querySelector('[data-scrim]');
  var bagBtn = document.getElementById('bagBtn');
  var lastFocus = null;

  function setCount(n) {
    var c = document.getElementById('bagCount');
    if (c) c.textContent = n ? n : '';
    if (bagBtn) bagBtn.setAttribute('aria-label', 'Bag, ' + n + ' ' + (n === 1 ? 'item' : 'items'));
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    var lines = drawer.querySelector('[data-lines]');
    var sum = drawer.querySelector('[data-sum]');
    if (!cart.items.length) {
      lines.innerHTML = '<li class="empty">YOUR BAG IS EMPTY. PICK A COLOUR AND LENGTH TO ADD A CABLE.</li>';
      sum.hidden = true;
      return;
    }
    sum.hidden = false;
    lines.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + esc(sizeImg(it.image, 160)) + '" alt="" width="72" height="72">' : '<span></span>';
      return '<li class="line">' + img +
        '<div><div class="n">' + esc(it.product_title) + '</div>' +
        '<div class="s">' + esc(it.variant_title || '') + '</div>' +
        '<div class="mini"><button type="button" data-q="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span>' +
        '<button type="button" data-q="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="rm" data-q="' + esc(it.key) + '" data-to="0">Remove</button></div>' +
        '<div class="p">' + money(it.final_line_price) + '</div></li>';
    }).join('');
    drawer.querySelector('[data-subtotal]').textContent = money(cart.total_price);
  }
  function fetchCart() {
    return fetch(R.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }
  function openBag() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    scrim.hidden = false; drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-close-bag]').focus();
    fetchCart();
  }
  function closeBag() {
    if (!drawer) return;
    scrim.hidden = true; drawer.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  if (drawer) {
    if (bagBtn) bagBtn.addEventListener('click', function (e) { e.preventDefault(); openBag(); });
    scrim.addEventListener('click', closeBag);
    drawer.querySelector('[data-close-bag]').addEventListener('click', closeBag);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeBag(); });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (!b) return;
      b.disabled = true;
      fetch(R.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-q'), quantity: Math.max(0, +b.getAttribute('data-to')) }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(fetchCart);
    });
  }

  /* ---------------- sign-up close ---------------- */
  var signup = document.querySelector('[data-signup]');
  if (signup) {
    try { if (localStorage.getItem('kb-signup-hidden') === '1' && location.hash !== '#kb-signup') signup.hidden = true; } catch (e) {}
    var x = signup.querySelector('[data-close-signup]');
    if (x) x.addEventListener('click', function () { signup.hidden = true; try { localStorage.setItem('kb-signup-hidden', '1'); } catch (e) {} });
  }

  /* ---------------- home page: open the shop in place ---------------- */
  var isIndex = document.body.classList.contains('tpl-index');
  var designMode = !!(window.Shopify && Shopify.designMode);
  var menuBtn = document.getElementById('menuBtn'), menuIcon = document.getElementById('menuIcon');
  function setMenu(open) {
    if (!menuBtn) return;
    if (menuIcon) menuIcon.setAttribute('d', open ? 'M9 1v16M1 9h16' : 'M1 9h16');
    menuBtn.setAttribute('aria-label', open ? 'Back to all colours' : 'Go to the shop');
  }
  function openShop(colour) {
    document.body.classList.add('shop-open');
    setMenu(true);
    if (colour && window.kbSelectColour) window.kbSelectColour(colour);
    else if (window.kbRefreshUrl) window.kbRefreshUrl();
    window.scrollTo(0, 0);
    var h = document.querySelector('[data-kb-product] h1');
    if (h) h.focus({ preventScroll: true });
  }
  function closeShop() {
    document.body.classList.remove('shop-open');
    setMenu(false);
    if (!designMode) { try { var u = new URL(location.href); u.searchParams.delete('variant'); history.replaceState(history.state, '', u.toString()); } catch (e) {} }
    window.scrollTo(0, 0);
  }
  if (isIndex && document.querySelector('[data-kb-product]')) {
    if (menuBtn) menuBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (document.body.classList.contains('shop-open')) closeShop(); else openShop();
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-open-shop]');
      if (!a) return;
      e.preventDefault();
      openShop(a.getAttribute('data-colour'));
    });
    var mark = document.querySelector('.head-left .mark');
    if (mark) mark.addEventListener('click', function (e) { if (document.body.classList.contains('shop-open')) { e.preventDefault(); closeShop(); } });
    if (new URLSearchParams(location.search).get('variant')) { document.body.classList.add('shop-open'); setMenu(true); }
  }

  /* ---------------- product page ---------------- */
  var root = document.querySelector('[data-kb-product]');
  if (!root) return;
  var dataEl = document.querySelector('[data-kb-data="' + root.getAttribute('data-section') + '"]');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = D.product, MEDIA = D.media || [], VM = D.variantMedia || {};
  var colourIdx = P.options.findIndex(function (n) { return /colo/i.test(typeof n === 'string' ? n : n.name); });
  if (colourIdx < 0 && P.options.length > 1) colourIdx = 0;
  var optNames = P.options.map(function (n) { return typeof n === 'string' ? n : n.name; });

  var params = new URLSearchParams(location.search);
  var start = P.variants.find(function (v) { return String(v.id) === params.get('variant'); }) ||
              P.variants.find(function (v) { return v.available; }) || P.variants[0];
  var sel = start.options.slice();
  var slide = 0, qty = 1;

  var $ = function (s) { return root.querySelector(s); };
  var stage = $('[data-stage]');

  function variantFor(opts) { return P.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }
  function current() { return variantFor(sel) || start; }
  function code(v) { return (v.sku || '').replace(/[-_ ]?\d+(\.\d+)?\s?M$/i, ''); }
  function colourOf(v) { return colourIdx >= 0 ? v.options[colourIdx] : ''; }
  function mediaById(id) { return MEDIA.find(function (m) { return m.id === id; }); }

  function slidesFor(colour) {
    if (colourIdx < 0 || !colour) return MEDIA.slice();
    var out = [], seen = {};
    P.variants.forEach(function (v) {
      if (v.options[colourIdx] !== colour) return;
      var m = VM[v.id] && mediaById(VM[v.id]);
      if (m && !seen[m.id]) { seen[m.id] = 1; out.push(m); }
    });
    var key = colour.toLowerCase();
    MEDIA.forEach(function (m) {
      if (!seen[m.id] && m.alt && m.alt.toLowerCase().indexOf(key) !== -1) { seen[m.id] = 1; out.push(m); }
    });
    return out.length ? out : MEDIA.slice();
  }

  function renderGallery() {
    var list = slidesFor(colourOf(current()));
    var n = list.length || 1;
    slide = ((slide % n) + n) % n;
    var m = list[slide];
    var img = stage.querySelector('img');
    if (m) {
      if (!img) { img = document.createElement('img'); img.width = 600; img.height = 600; stage.prepend(img); }
      img.src = m.src; img.removeAttribute('srcset'); img.alt = m.label || m.alt || '';
    }
    $('[data-dots]').innerHTML = list.length > 1 ? list.map(function (_, i) {
      return '<button type="button" class="dot" data-i="' + i + '" aria-label="Photo ' + (i + 1) + ' of ' + list.length + '" aria-current="' + (i === slide) + '"><span></span></button>';
    }).join('') : '';
    var arrows = root.querySelectorAll('.arrow');
    for (var k = 0; k < arrows.length; k++) arrows[k].hidden = list.length < 2;
  }

  function renderAlso() {
    var block = root.querySelector('[data-also-block]');
    if (colourIdx < 0) { block.hidden = true; return; }
    var values = [];
    P.variants.forEach(function (v) { var c = v.options[colourIdx]; if (values.indexOf(c) === -1) values.push(c); });
    var cur = colourOf(current());
    var others = values.filter(function (c) { return c !== cur; });
    block.hidden = !others.length;
    root.querySelector('[data-also]').innerHTML = others.map(function (c) {
      var v = P.variants.find(function (x) { return x.options[colourIdx] === c; });
      var m = slidesFor(c)[0];
      return '<a class="swatch" href="?variant=' + v.id + '" data-colour="' + esc(c) + '" aria-label="Show ' + esc(c) + '"><span class="ph">' +
        (m ? '<img src="' + esc(m.thumb || m.src) + '" alt="" loading="lazy">' : '') + '</span><span class="cap"><span class="code">' + esc(code(v)) + ' · </span>' + esc(c) + '</span></a>';
    }).join('');
  }

  function renderOptions() {
    var groups = root.querySelectorAll('[data-opt]');
    for (var g = 0; g < groups.length; g++) {
      var idx = +groups[g].getAttribute('data-opt');
      var btns = groups[g].querySelectorAll('[data-value]');
      for (var b = 0; b < btns.length; b++) {
        var val = btns[b].getAttribute('data-value');
        btns[b].setAttribute('aria-pressed', String(sel[idx] === val));
        var trial = sel.slice(); trial[idx] = val;
        var tv = variantFor(trial);
        btns[b].setAttribute('data-unavailable', String(!tv || !tv.available));
        if (idx === colourIdx) {
          var t = TINTS[val.toLowerCase()];
          if (t) { btns[b].style.setProperty('--tint', t[0]); btns[b].style.setProperty('--tint-hover', t[1]); }
        } else if (D.showLengthPrices && tv) {
          btns[b].innerHTML = esc(val) + '<small>' + money(tv.price) + '</small>';
        }
      }
    }
  }

  function renderBuy() {
    var v = current();
    var label = [code(v), colourIdx >= 0 ? colourOf(v) : ''].filter(Boolean).join(' · ');
    $('[data-eyebrow]').textContent = label;
    $('[data-caption]').textContent = label;
    $('[data-price]').innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
    $('[data-variant-id]').value = v.id;
    $('[data-qty]').textContent = qty;
    $('[data-qty-input]').value = qty;
    var add = $('[data-add]');
    add.disabled = !v.available;
    add.textContent = v.available ? 'ADD TO BAG · ' + money(v.price * qty) : 'SOLD OUT';
    // keep Shopify's own query params (theme preview, editor session); only swap the variant
    if (!designMode && (!isIndex || document.body.classList.contains('shop-open'))) {
      try { var u = new URL(location.href); if (u.searchParams.get('variant') !== String(v.id)) { u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } } catch (e) {}
    }
  }

  function renderAll() { renderOptions(); renderGallery(); renderAlso(); renderBuy(); }
  window.kbSelectColour = function (c) {
    if (colourIdx < 0) { renderAll(); return; }
    var t = sel.slice(); t[colourIdx] = c;
    if (!variantFor(t)) { var a3 = P.variants.find(function (v) { return v.options[colourIdx] === c; }); if (a3) t = a3.options.slice(); }
    sel = t; slide = 0; renderAll();
  };
  window.kbRefreshUrl = renderBuy;

  root.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-opt] [data-value]');
    if (opt) {
      var idx = +opt.closest('[data-opt]').getAttribute('data-opt');
      var val = opt.getAttribute('data-value');
      var trial = sel.slice(); trial[idx] = val;
      if (!variantFor(trial)) { // keep the click, pick the nearest existing combination
        var alt = P.variants.find(function (v) { return v.options[idx] === val; });
        if (alt) trial = alt.options.slice();
      }
      if (idx === colourIdx) slide = 0;
      sel = trial; $('[data-status]').textContent = '';
      renderAll();
      return;
    }
    var sw = e.target.closest('[data-colour]');
    if (sw && colourIdx >= 0) {
      e.preventDefault();
      var t2 = sel.slice(); t2[colourIdx] = sw.getAttribute('data-colour');
      if (!variantFor(t2)) { var a2 = P.variants.find(function (v) { return v.options[colourIdx] === t2[colourIdx]; }); if (a2) t2 = a2.options.slice(); }
      sel = t2; slide = 0; renderAll();
      stage.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    if (e.target.closest('[data-prev]')) { slide--; renderGallery(); return; }
    if (e.target.closest('[data-next]')) { slide++; renderGallery(); return; }
    var dot = e.target.closest('[data-dots] [data-i]');
    if (dot) { slide = +dot.getAttribute('data-i'); renderGallery(); return; }
    if (e.target.closest('[data-dec]')) { qty = Math.max(1, qty - 1); renderBuy(); return; }
    if (e.target.closest('[data-inc]')) { qty = Math.min(10, qty + 1); renderBuy(); return; }
  });
  stage.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { slide--; renderGallery(); }
    if (e.key === 'ArrowRight') { slide++; renderGallery(); }
  });
  var x0 = null;
  stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (x0 == null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) { slide += dx < 0 ? 1 : -1; renderGallery(); }
    x0 = null;
  });

  $('[data-buy-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var v = current(), add = $('[data-add]'), status = $('[data-status]');
    if (!v.available) return;
    add.disabled = true;
    fetch(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        var rest = v.options.filter(function (o, i) { return i !== colourIdx; }).join(' ');
        status.textContent = ('ADDED ' + qty + ' × ' + [code(v), colourOf(v), rest].filter(Boolean).join(' ') + ' TO YOUR BAG.').toUpperCase();
        add.disabled = false;
        openBag();
      })
      .catch(function (err) {
        add.disabled = false;
        status.textContent = (err && (err.description || err.message)) || 'That didn’t go into your bag. Try again in a moment.';
      });
  });

  // on phones, "Also in" sits under the add-to-bag button; on wider screens it stays under the photos
  var gallery = root.querySelector('.gallery'), buy = root.querySelector('.buy'), alsoBlock = root.querySelector('[data-also-block]');
  var mq = window.matchMedia('(max-width: 960px)');
  function placeAlso() {
    if (mq.matches) { if (alsoBlock.previousElementSibling !== buy) buy.after(alsoBlock); }
    else if (alsoBlock.parentElement !== gallery) gallery.appendChild(alsoBlock);
  }
  if (mq.addEventListener) mq.addEventListener('change', placeAlso); else mq.addListener(placeAlso);
  placeAlso();

  renderAll();
})();
